export const usuario = [
  {
    label: "Id",
    name: "idusuario",
    type: "INTEGER",
    readonly: true,
    showOnList: true,
  },
  {
    label: "Nombre",
    name: "nombre",
    type: "STRING",
    showOnList: true,
    showAsLabel: true,
  },
  {
    label: "Email",
    name: "mail",
    type: "STRING",
    showOnList: true,
  },
  {
    label: "Contraseña",
    name: "password",
    type: "PASSWORD",
    hideOnShow: true,
    allowNull: (record) => {
      return record.idusuario ? true : false;
    },
  },
  {
    label: "Idioma",
    name: "idioma",
    type: "STRINGINLIST",
    showOnList: true,
    options: ["Español", "English"],
    allowNull: true,
  },
  {
    label: "Roles",
    name: "roles",
    type: "rol",
    showOnList: true,
    multiple: true,
    doNotSort: true,
  },
];
